import { useMutation } from 'react-query';
import { updateCostCenterSortorder } from 'RestAPIs/cost-centers/sortorder';
import { AxiosResponse } from 'axios';

interface SortOrderMutationVariables {
  sortorder: number;
  waId: number;
  costCenterId: number;
}

interface SortOrderMutationResponse {
  success: boolean;
  message: string;
}

const useUpdateCostCenterSortorder = () => {
  const mutation = useMutation<
    AxiosResponse<SortOrderMutationResponse>,
    Error,
    SortOrderMutationVariables
  >(async ({ sortorder, waId, costCenterId }) => {
    return updateCostCenterSortorder({ sortorder, waId, costCenterId });
  });

  return mutation;
};

export default useUpdateCostCenterSortorder;
